import {makeStyles} from "@material-ui/core";
import {colors} from "../../../../../shared/colors";

export const defaultSelectStyles = makeStyles(() => ({
    dropdownStyle: {
        "& li": {
            padding: "0.875em",
            whiteSpace: "normal",
            "&.Mui-selected": {
                background: "none",
                "& > svg": {
                    display: "flex"
                },
                "& > .MuiTypography-root": {
                    color: colors.primary.dark,
                }
            }
        }
    },
    boldText: {
        fontWeight: 500
    },
    doneIcon: {
        color: colors.primary.dark,
        display: "none"
    },
    text: {
        flexGrow: 1
    }
}));
